// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__zicBT","tabs":"Info_tabs__I2zMW","tabItem":"Info_tabItem__4vQuf","active":"Info_active__H3Ym9","content":"Info_content__NS96y"};